<script>
import partner1 from '@/assets/img/partners/jll_logo.svg';
import partner2 from '@/assets/img/partners/clickup_logo.svg';
import partner3 from '@/assets/img/partners/lyft_logo.svg';
import partner4 from '@/assets/img/partners/indeed_logo.svg';
import partner5 from '@/assets/img/partners/sigma_computing_logo.svg';
import LogoAnimation from '@/assets/img/logo-animation.png';
import ZendeskLogo from '@/assets/icons/zendesk_logo3.svg';
import Typography from '../../base/Typography';
import ReviewSlideShow from './ReviewSlideShow';

export default {
  components: {
    Typography,
    ReviewSlideShow,
  },

  props: {
    hideLogo: Boolean,
  },

  data() {
    return {
      partner1,
      partner2,
      partner3,
      partner4,
      partner5,
      sectionActive: [],
      LogoAnimation,
      ZendeskLogo,
    };
  },

  mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, true);
  },

  unmounted() {
    window.removeEventListener('scroll', this.onScroll, true);
  },

  methods: {
    onScroll() {
      const scrollY = window.scrollY;
      const section1 = document.getElementById('review-section') ?? {
        offsetTop: 0,
      };

      const section1Top = section1.offsetTop + 100;
      const section1Height = section1.offsetHeight;
      const section1Bottom = section1Top + section1Height;

      const checkPoint = scrollY + window.innerHeight - 100;

      if (checkPoint >= section1Top && scrollY <= section1Bottom) {
        this.sectionActive.push(1);
      }
    },
  },
};
</script>
<template>
  <div class="tw-bg-purple-100 tw-py-20 tw-px-6">
    <div id="review-section" class="tw-max-w-container-1 tw-mx-auto tw-py-2">
      <div class="tw-grid md:tw-flex tw-gap-8">
        <div>
          <Typography
            variant="headline-3"
            class="tw-translate-y-0 tw-transition-all tw-duration-700 md:tw-w-[300px]"
            :class="{
              'tw-translate-y-[200px] tw-opacity-0 tw-transition-none':
                !sectionActive.includes(1),
            }"
          >
            Trusted by companies worldwide
          </Typography>
        </div>
        <div
          class="tw-translate-y-0 tw-transition-all tw-duration-700 tw-w-full"
          :class="{
            'tw-translate-y-[200px] tw-opacity-0 tw-transition-none':
              !sectionActive.includes(1),
          }"
        >
          <ReviewSlideShow />
        </div>
      </div>
      <div v-if="!hideLogo" class="tw-mt-12 tw-relative tw-overflow-hidden">
        <div class="logo-track tw-flex tw-gap-8 tw-items-center">
          <img :src="LogoAnimation" class="tw-w-[1170px]" />
          <img :src="ZendeskLogo" class="tw-h-10" />
        </div>
        <div
          class="tw-absolute logo-track2 tw-left-0 tw-top-0 tw-flex tw-gap-8 tw-items-center"
        >
          <img :src="LogoAnimation" class="tw-w-[1170px]" />
          <img :src="ZendeskLogo" class="tw-h-10" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.logo-track {
  animation: scroll 100s linear infinite;
  width: 1270px;
}
.logo-track2 {
  animation: scroll2 100s linear infinite;
  width: 1270px;
}
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-1340px);
  }
}
@keyframes scroll2 {
  from {
    transform: translateX(1340px);
  }
  to {
    transform: translateX(0);
  }
}
</style>
